export default __webpack_public_path__ + "static/media/05.7ff60db3.svg";